export const screen = {
    SIM_MANAGEMENT: 'sim management',
    DASHBOARD: 'dashboard',
    TICKETING: 'ticketing',
    DEVICE: 'device',
    CONROL_CENTER: 'control center'
};

export const scope_area = {
    DASHBOARD: 'dashboard click',
    DASHBOARD_CUSTOMIZATION: 'dashboard customization',
    SIM_EDIT: 'sim edit',
    SIM_FILTER: 'sim filter',
    SIM_REPORT: 'sim report',
    SIM_COLUMNS: 'sim columns',
    TICKETING_FILTER: 'ticketing filter',
    TICKETING_COLUMNS: 'ticketing columns',
    TICKETING_REPORT: 'ticketing report',
    DEVICE_FILTER: 'device filter',
    DEVICE_COLUMNS: 'device columns',
    CONTROL_CENTER: 'control center'
};

export const action = {
    CLOSED: 'closed',
    CLICKED: 'clicked',
    COMPLETED: 'completed',
    DISMISSED: 'dismissed',
    EDITED: 'edited',
    ENGAGED: 'engaged',
    FAILED: 'failed',
    OPENED: 'opened',
    SUBMITTED: 'submitted',
    VIEWED: 'viewed',
    LOADED: 'loaded'
};

export const module_object = {
    SIM: 'sim',
    DASHBOARD: 'dashboard',
    DASHBOARD_INVENTORY: 'dashboard inventory',
    DASHBOARD_FLOOR_PLANS: 'dashboard floor plans',
    DASHBOARD_CREATE_USER: 'dashboard create user',
    DASHBOARD_DEVICE: 'dashboard device',
    DASHBOARD_LAST_USAGE: 'dashboard last usage',
    DASHBOARD_TICKETING: 'dashboard ticketing',
    DASHBOARD_ASSIGN_ROLE: 'dashboard assign role',
    DASHBOARD_SIM_CARD_INVENTORY: 'dashboard sim card inventory',
    DASHBOARD_AVG_THROUGHPUTS: 'dashboard average throughputs',
    DASHBOARD_CREATE_TICKET: 'dashboard create ticket',
    DASHBOARD_RECENT_ALERTS: 'dashboard recent alerts',
    TICKETING: 'ticketing',
    DEVICE: 'device',
    CONTROL_CENTER: 'control center'
};

export const type = {
    PSIM: 'psim',
    ESIM: 'esim'
};

export const getBaseFields = () => ({
    org: 'VERIZON',
    purpose: 'PRODUCT',
    scope: 'OSND'
});

// EP5G_7031980 // Osnd_!2011

// Pendo utils starts
//sim-edit flow
// SIM Details Viewed
// 2. SIM Details edited
// 3.
// 	Successful - SIM Details saved successfully
// 	Fail - SIM Details save failed
// 4. Cancel/Cross Icon click - SIM Details closed
export const PENDO_EVENT = {
    DASHBOARD_PAGE_VIEWED: 'Dashboard: Page Viewed',
    DASHBOARD_VIEW_ALL_MORE_CLICKED: 'Dashboard: View All Clicked',
    DASHBOARD_CUSTOMIZE_MODAL_OPENED: 'Dashboard: Open customize modal',
    DASHBOARD_CUSTOMIZE_SAVE_BUTTON_CLICKED: 'Dashboard: Click on save button within customize modal',
    SIM_PAGE_VIEWED: 'Sim: Page Viewed',
    SIM_DETAIL_VIEWED: 'Sim: Detail Viewed',
    SIM_DETAIL_EDITED: 'Sim: Detail Edited',
    SIM_DETAIL_SAVE_SUCCESS: 'Sim: Detail Saved successfully',
    SIM_DETAIL_SAVE_FAILURE: 'Sim: Detail failed to save',
    SIM_DETAIL_CLOSED: 'Sim: Details closed',
    SIM_MANAGEMENT_PAGE_LOADED: 'Sim: Land on SIM management page',
    SIM_FILTER_CLICKED: 'Sim: Click on filter button',
    SIM_SEARCH_CLICKED: 'Sim: Click on search textbox',
    SIM_FILTER_OPTION_CLICKED: 'Sim: Click on ICCID, name, IMSI, IP address, APN, profile or status',
    SIM_ICCID_CLICKED: 'Sim: Click on ICCID',
    SIM_NAME_CLICKED: 'Sim: Click on name',
    SIM_IMSI_CLICKED: 'Sim: Click on IMSI',
    SIM_IP_ADDRESS_CLICKED: 'Sim: Click on IP address',
    SIM_APN_CLICKED: 'Sim: Click on APN',
    SIM_LOCATION_CLICKED: 'Sim: Click on location',
    SIM_PROFILE_CLICKED: 'Sim: Click on profile',
    SIM_STATUS_CLICKED: 'Sim: Click on status',
    SIM_DOWNLOAD_LIST_MODAL_OPENED: 'Sim: Open download list modal',
    SIM_DOWNLOAD_MODAL_BUTTON_CLICKED: 'Sim: Click on download button within modal',
    SIM_CSV_ICON_CLICKED: 'Sim: Click on csv icon',
    SIM_DOWNLOAD_ALL_COLUMNS_CLICKED: 'Sim: Click on download all columns checkbox',
    SIM_MANAGE_COLUMNS_MODAL_OPENED: 'Sim: Open manage columns modal',
    SIM_MANAGE_COLUMNS_OK_CLICKED: 'Sim: Click on manage columns ok button',
    TICKETING_PAGE_LOADED: 'Ticketing: Land on ticketing page',
    TICKETING_FILTER_CLICKED: 'Ticketing: Click on filter button',
    TICKETING_SEARCH_CLICKED: 'Ticketing: Click on search textbox',
    TICKETING_FILTER_OPTION_CLICKED: 'Ticketing: Click on problem type, status, severity or location',
    TICKETING_PROBLEM_TYPE_CLICKED: 'Ticketing: Click on problem type',
    TICKETING_STATUS_CLICKED: 'Ticketing: Click on status',
    TICKETING_SEVERITY_CLICKED: 'Ticketing: Click on severity',
    TICKETING_LOCATION_CLICKED: 'Ticketing: Click on location',
    TICKETING_DOWNLOAD_REPORT_MODAL_OPENED: 'Ticketing: Open download report modal',
    TICKETING_CSV_ICON_CLICKED: 'Ticketing: Click on csv icon',
    TICKETING_PDF_ICON_CLICKED: 'Ticketing: Click on pdf icon',
    TICKETING_DOWNLOAD_ALL_COLUMNS_CLICKED: 'Ticketing: Click on download all columns checkbox',
    TICKETING_DOWNLOAD_MODAL_BUTTON_CLICKED: 'Ticketing: Click on download button within modal',
    TICKETING_MANAGE_COLUMNS_MODAL_OPENED: 'Ticketing: Open manage columns modal',
    TICKETING_MANAGE_COLUMNS_OK_CLICKED: 'Ticketing: Click on manage columns ok button',
    DEVICE_PAGE_LOADED: 'Devices: Land on Devices page',
    DEVICE_FILTER_CLICKED: 'Devices: Click on filter button',
    DEVICE_SEARCH_CLICKED: 'Devices: Click on search textbox',
    DEVICE_FILTER_OPTION_CLICKED: 'Devices: Click on ICCID, IMSI, IMEI, device type, SIM type, status or location',
    DEVICE_ICCID_CLICKED: 'Devices: Click on ICCID',
    DEVICE_IMSI_CLICKED: 'Devices: Click on IMSI',
    DEVICE_IMEI_CLICKED: 'Devices: Click on IMEI',
    DEVICE_TYPE_CLICKED: 'Devices: Click on device type',
    DEVICE_SIM_TYPE_CLICKED: 'Devices: Click on SIM type',
    DEVICE_STATUS_CLICKED: 'Devices: Click on status',
    DEVICE_LOCATION_CLICKED: 'Devices: Click on location',
    DEVICE_MANAGE_COLUMNS_MODAL_OPENED: 'Devices: Open manage columns modal',
    DEVICE_MANAGE_COLUMNS_OK_CLICKED: 'Devices: Click on manage columns ok button',
    CONTROL_CENTER_SUPPORT_CLICKED: 'Control center: Click on support icon',
    CONTROL_CENTER_CREATE_TICKET_CLICKED: 'Control center: Click on create ticket icon',
    CONTROL_CENTER_USER_GUIDE_CLICKED: 'Control center: Click on user guide menu item',
    CONTROL_CENTER_VIDEO_TUTORIALS_CLICKED: 'Control center: Click on video tutorials menu item',
    CONTROL_CENTER_FEEDBACK_FORM_CLICKED: 'Control center: Click on feedback form icon'
};

export const logPendoEvent = (event, eventParams) => {
    if (!window.pendo) return;
    pendo.track(event, eventParams);
};

export const trackDashboardLoad = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.VIEWED,
            object: module_object.DASHBOARD
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_PAGE_VIEWED, trackingObj);
};

export const trackDashboardDeviceClick = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD_DEVICE
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_VIEW_ALL_MORE_CLICKED, trackingObj);
};

export const trackDashboardFloorPlanClick = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD_FLOOR_PLANS
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_VIEW_ALL_MORE_CLICKED, trackingObj);
};

export const trackDashboardTicketingClick = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD_TICKETING
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_VIEW_ALL_MORE_CLICKED, trackingObj);
};

export const trackDashboardnetworkInventoryClick = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD_INVENTORY
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_VIEW_ALL_MORE_CLICKED, trackingObj);
};

export const trackDashboardSimClick = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD_SIM_CARD_INVENTORY
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_VIEW_ALL_MORE_CLICKED, trackingObj);
};

export const trackDashboardAvgUlDlClick = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD_AVG_THROUGHPUTS
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_VIEW_ALL_MORE_CLICKED, trackingObj);
};

export const trackDashboardAlertsClick = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD_RECENT_ALERTS
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_VIEW_ALL_MORE_CLICKED, trackingObj);
};

export const trackDashboardCustomizeModalOpened = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD_CUSTOMIZATION,
            screen: screen.DASHBOARD,
            action: action.OPENED,
            object: module_object.DASHBOARD
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_CUSTOMIZE_MODAL_OPENED, trackingObj);
};

export const trackDashboardCustomizeSaveButtonClicked = (specificParams) => {
    const trackingObj = Object.assign(
        {},
        getBaseFields(),
        {
            scope_area: scope_area.DASHBOARD_CUSTOMIZATION,
            screen: screen.DASHBOARD,
            action: action.CLICKED,
            object: module_object.DASHBOARD
        },
        specificParams
    );
    logPendoEvent(PENDO_EVENT.DASHBOARD_CUSTOMIZE_SAVE_BUTTON_CLICKED, trackingObj);
};
// Pendo utils ends
